import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");


export const getListFacture = createAsyncThunk("facture/listFacture", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/listFacture", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const facture = await response.json();
  return facture;
});

export const allFacture = createAsyncThunk("facture/allFacture", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/allFacture", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const facture = await response.json();
  return facture;
});

export const getSageFacture = createAsyncThunk("facture/getSageFacture", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getSageFacture/" + action.code+"/"+action.id_site, {
    method: "Get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});



export const getQrCodeMedis = createAsyncThunk(
  "facture/getQrCodeMedis",
  async (num) => {
    const response = await fetch(Configuration.BACK_BASEURL + `facture/client/medis/${num}`, { method: "GET" });
    const facture = await response.json();
    return facture;
  }
);

export const getQrCodeNeapolis = createAsyncThunk(
  "facture/getQrCodeNeapolis",
  async (num) => {
    const response = await fetch(Configuration.BACK_BASEURL + `facture/client/neapolis/${num}`, { method: "GET" });
    const facture = await response.json();
    return facture;
  }
);



export const allFactureTxt = createAsyncThunk("facture/allFactureTxt", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/allFactureTxt", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const facture = await response.json();
  return facture;
});
export const getallfile = createAsyncThunk("facture/getallfile", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getallfile", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});

export const deleteFileD = createAsyncThunk("facture/deleteFileD", async (file) => {

  const response = await fetch(Configuration.BACK_BASEURL + "facture/deleteFileD/" + file, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});
export const thumbnail = createAsyncThunk("facture/thumbnail", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/thumbnail", {
    method: "Post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action)
  });
  const facture = await response.json();
  return facture;
});

export const getFactureById = createAsyncThunk("facture/getFactureById", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getFactureById/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});

export const getFactureLivById = createAsyncThunk("facture/getFactureLivById", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getFactureLivById/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});
export const getFactureByIdCmd = createAsyncThunk("facture/getFactureByIdCmd", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getFactureByIdCmd/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});

export const getFactureLivByIdCmd = createAsyncThunk("facture/getFactureLivByIdCmd", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getFactureLivByIdCmd/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});


//getDetailFacture
export const getDetailFacture = createAsyncThunk("facture/getDetailFacture", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getDetailFacture/" + id, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});


export const fetchGrossisteFacture = createAsyncThunk("facture/fetchGrossisteFacture", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/fetchGrossisteFacture", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const facture = await response.json();
  return facture;
});


//getDetailFacture
export const getDetailFactureCmd = createAsyncThunk("facture/getDetailFactureCmd", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getDetailFactureCmd/" + action, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});


//getDetailFactureProduitRepture
export const getDetailFactureProduitRepture = createAsyncThunk("facture/getDetailFactureProduitRepture", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getDetailFactureProduitRepture/" + action, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});

//getDetailFactureproforma
export const getDetailFactureCmdProforma = createAsyncThunk("facture/getDetailFactureCmdProforma", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "facture/getDetailFactureCmdProforma/" + action.num_commande+'/'+action.num_facture, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const facture = await response.json();
  return facture;
});

const factureReduce = createSlice({
  name: "facture",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {




  },
  extraReducers: {

  },
});

export const { } = factureReduce.actions;

export default factureReduce.reducer;
